<template>
  <div class="luttica-data-grid">
    <CloudTable
      :data="data"
      :loading="loading"
      :columns="allColumns"
      :sortList="sortList"
      :mulitSort="mulitSort"
      :border="border"
      :height="height"
      :showTitle="showTitle"
      :size="size"
      :refreshTable="refreshTable"
      :row-class-name="rowClassName"
      @on-sort-change="handleSortChange"
      @on-filter-change="handleFilterChange"
      @handleScrollBar="handleScroll"
      stripe
      v-on="$listeners"
      ref="pubTable"
    >
      <template slot="footer">
        <slot name="footer" v-if="$slots.footer"></slot>
      </template>
      <template
        v-for="item in childTable ? allTransCol : allColumns"
        :slot="item.slot"
        slot-scope="{ row, index, allColumns }"
      >
        <template v-if="item.slot">
          <slot :name="item.slot" v-bind="{ row, index, allColumns }"></slot>
        </template>
      </template>
    </CloudTable>

    <ShowColumns
      :headers="allColumns"
      v-if="showMore"
      @on-change-columns="handleChangeColumns"
    ></ShowColumns>
    <div
      class="luttica-data-grid__page"
      :class="{
        'is-extra': $slots.extra,
      }"
      v-if="page"
    >
      <div class="extra" v-if="$slots.extra">
        <slot name="extra"></slot>
      </div>
      <CloudPage
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
        :total="page.total"
        :current.sync="page.current"
        :pageSize="page.pageSize"
        :pageSizeOpts="page.pageSizeOpts"
        show-sizer
        placement="top"
        :show-elevator="showElevator"
        show-total
      ></CloudPage>
    </div>
  </div>
</template>

<script>
import './style.less';
import { humpToLine, arrChangeOne } from '@/utils/util';
import ShowColumns from './ShowColumns.vue';
// page事件列表
const pageEventFnList = ['on-change', 'on-page-size-change'];

export default {
  name: 'LutticaDataGrid',
  components: {
    ShowColumns,
  },
  props: {
    border: Boolean,
    loading: Boolean,
    size: String,
    refreshTable: {
      type: Boolean,
      default: true,
    },
    columns: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    sortList: {
      type: Array,
      default() {
        return [];
      },
    },
    data: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    mulitSort: {
      type: Boolean,
      default: true,
    },
    showMore: {
      type: Boolean,
      default: false,
    },
    childTable: {
      type: Boolean,
      default: false,
    },
    page: {
      type: [Boolean, Object],
      required: true,
      default: false,
    },
    rowClassName: {
      type: Function,
      default() {
        return () => {};
      },
    },
    showTitle: Boolean,
    showElevator: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      allTransCol: [],
      allColumns: [],
    };
  },
  computed: {
    // 表格高度
    height() {
      const { height } = this.$attrs;
      if (height) {
        return this.page ? height - 50 : height;
      }
      return undefined;
    },
    // page属性处理
    pageProps() {
      const pageProps = {};
      if (this.page && Object.keys(this.page).length) {
        Object.keys(this.page).forEach(item => {
          pageProps[humpToLine(item)] = this.page[item];
        });
      }
      // if (!pageProps.total) {
      //   pageProps.total = this.$attrs.data.length || 0;
      // }
      return pageProps;
    },
    // pageEvent属性处理
    pageEventProps() {
      const pageEventProps = {};
      // 首先将默认的event事件加到pageEventProps中
      pageEventFnList.forEach(item => {
        pageEventProps[item] = this.defaultPageFn;
      });
      // 然后将外面传进来的方法进行替换
      if (this.page && this.page.on && Object.keys(this.page.on).length) {
        Object.keys(this.page.on).forEach(item => {
          pageEventProps[humpToLine(item)] = this.page.on[item];
        });
      }
      return pageEventProps;
    },
    // table refs
    tableRefs() {
      return this.$refs.pubTable;
    },
  },
  created() {
    const forChild = chil => {
      chil.forEach(item => {
        if (item.children) {
          forChild(item.children);
        } else {
          Object.assign(item, {
            show: item.show !== false,
          });
        }
      });
      return chil;
    };
    const allColumns = forChild(this.columns);
    this.allColumns = [...allColumns];
    if (this.childTable) {
      const allTransCol = arrChangeOne(allColumns);
      this.allTransCol = [...allTransCol];
    }
  },
  watch: {
    columns: {
      handler(value) {
        const forChild = chil => {
          chil.forEach(item => {
            if (item.children) {
              forChild(item.children);
            } else {
              Object.assign(item, {
                show: item.show !== false,
              });
            }
          });
          return chil;
        };
        const allColumns = forChild(value);
        this.allColumns = [...allColumns];
        if (this.childTable) {
          const allTransCol = arrChangeOne(allColumns);
          this.allTransCol = [...allTransCol];
        }
      },
      deep: true,
    },
  },
  methods: {
    handleScroll(v, h, n) {
      this.$emit('handleScroll', v, h, n);
    },
    scrollBar() {
      return this.$refs.pubTable.tableScroll();
    },
    defaultPageFn() {},
    handleChangeColumns(value, index) {
      const item = this.allColumns[index];
      item.show = value;
      this.allColumns.splice(index, 1, { ...item });
      this.$emit('handleChangeColumns', value, index);
    },
    pageChange(data) {
      this.$refs.pubTable.scrollBarRefresh('noChangeX');
      this.pageEventProps['on-change'](data);
    },
    pageSizeChange(data) {
      this.pageEventProps['on-page-size-change'](data);
    },
    handleSortChange(obj) {
      const forChild = chil => {
        let list = [];
        chil.forEach(val => {
          if (val.children) {
            list = list.concat(forChild(val.children));
          } else {
            list.push(val);
          }
        });
        return list;
      };
      const allHeader = forChild(this.allColumns);
      const item = allHeader.find(column => column.key === obj.key);
      item.sortType = obj.order;
      this.$emit('update:sortList', obj.sortList);
      this.$emit('sort-change', obj);
    },
    handleFilterChange(obj) {
      const item = this.allColumns.find(column => column.key === obj.key);
      /* eslint-disable */
      item.filteredValue = obj._filterChecked;
      // this.$emit('on-filter-change', obj);
    },
  },
};
</script>
